const ar = {
  "Home": "مسكن",
  "Liquidity": "السيولة",
  "Swap": "تبديل",
  "Stake": "الرهان",
  "Portfolio": "مَلَفّ",
  "Connect Wallet": "ربط المحفظة",
  "Disconnect": "قطع الاتصال",
  "Welcome to TiFi Bank!": "!TiFi مرحبًا بكم في بنك",
  "The First Decentralized Bank for Allverse": "Allverse التبادل اللامركزي الأول لشركة",
  "Exchange Cryptos with other Cryptos": "تبادل العملات المشفرة مع العملات المشفرة الأخرى",
  "GO TO SWAP": "الانتقال إلى المبادلة",
  "Enjoy Earning by Providing Liquidity": "تمتع بالكسب من خلال توفير السيولة",
  "GO TO LIQUIDITY": "اذهب إلى السيولة",
  "Provide Observerbility of Pool Portfolio": "توفير إمكانية مراقبة محفظة الأوراق المالية",
  "GO TO PORTFOLIO": "الانتقال إلى الحافظة",
  "We appeciate for any feedbacks, please submit your feedbacks": "نحن نقدر أي ردود فعل ، يرجى إرسال ملاحظاتك",
  ", and you will have a chance to get TIFI airdrop!": "!الجوي TIFI وستتاح لك فرصة الحصول على إنزال ،",
  "Haven’t got a crypto wallet yet?": "ألم تحصل على محفظة تشفير حتى الآن؟",
  "Learn How to Connect": "تعرف على كيفية الاتصال",
  "More": "أكثر",
  "Price Chart": "مخطط الأسعار",
  "The market price chart from public exchanges. It shows the historical prices and the latest price in the chart may not be the same as the price show on the right panel of the page.": "مخطط سعر السوق من التبادلات العامة. يعرض الأسعار التاريخية وقد لا يكون آخر سعر في الرسم البياني هو نفسه السعر المعروض على اللوحة اليمنى من الصفحة.",
  "24H": "1 د",
  "7D": "7 د",
  "14D": "14 د",
  "30D": "30 د",
  "1Y": "1 ص",
  "Term of Use": "شروط الاستخدام",
  "Privacy Policy": "سياسة الخصوصية",
  "Cookies Policy": "اتفاقية ملفات تعريف الارتباط",
  "Disclaimer": "تنصل",
  "FAQ": "التعليمات",
  "Contact Us": "اتصل بنا",
  "All rights reserved.": ".كل الحقوق محفوظة",
  "Balance": "الرصيد",
  "The number is invalid, maybe too big?": "الرقم غير صالح ، ربما كبير جدًا؟",
  "You are not on the BSC main net. Please switch to the main net.": ".أنت لست على الشبكة الرئيسية .BSC الرجاء التبديل إلى الشبكة الرئيسية",
  "You have selected the same tokens, please select a different token.": ".لقد حددت نفس الرموز ، يرجى تحديد رمز مختلف",
  "The pair doesn't exist, please select another pair.": ".الزوج غير موجود ، الرجاء تحديد زوج آخر, رصيد غير كافي للمعاملة",
  "Not enough balance for the transaction.": "رصيد غير كافي للمعاملة",
  "Transaction rejected by user.": ".رفض المستخدم المعاملة",
  "Transaction Submitted!": "!تم إرسال المعاملة",
  "Check Transaction on BSCScan": "BSCScan التحقق من المعاملة على",
  "Swap Success!": "!نجاح المبادلة",
  "Approved, now you can swap!": "!موافق عليه ، يمكنك المبادلة الآن",
  "Approval Request submitted. Please hold on.": ".تم إرسال طلب الموافقة. يرجى الانتظار",
  "successful added": "تمت الإضافة بنجاح",
  "added failed": "الفاشلة المضافة",
  "Cannot find address of": "لا يمكن العثور على عنوان",
  ", have you connected MetaMask?": "؟MetaMask هل قمت بتوصيل ،",
  "copied": "نسخ",
  "Price": "سعر",
  "per": "لكل",
  "Price Impact Too High": "تأثير السعر مرتفع جدًا",
  "Insufficient Liquidity for This Trade": "تأثير السعر مرتفع جدًا",
  "Insufficient Balance": "رصيد غير كاف",
  "Swap Fee": "رسوم المبادلة",
  "Swap Fee is 0.2%, where:": ":رسوم المبادلة 0.2٪ ، حيث",
  "0.18% is paid to LP Providers": "يتم دفع 0.18٪ إلى موفري LP",
  "0.02% to the TiFi treasury": "0.02٪ إلى خزينة TiFi",
  "Price Impact": "تأثير السعر",
  "The difference between the market price and estimated price due to trade size.": "الفرق بين سعر السوق والسعر المقدر بسبب حجم الصفقة.",
  "Route": "طريق",
  "Routing through these tokens resulted in the best price for your trade.": ".أدى التوجيه من خلال هذه الرموز إلى الحصول على أفضل سعر لصفقتك",
  "TIFI Sell Fee": "TIFI رسوم بيع",
  "There is 2% of fee when selling TIFI, check ": "شيك ،TIFI هناك 2٪ من الرسوم عند بيع",
  "TiFi Token Whitepaper": "المميزة TiFi ورقة عمل",
  " for more details.": ".لمزيد من التفاصيل ",
  "TIFI Buy Fee": "TIFI رسوم شراء",
  "There is 1% of fee when buying TIFI, check ": "تحقق ، TIFI هناك 1٪ من الرسوم عند شراء",
  "Swap from": "مبادلة من",
  "Swap to": "التبديل إلى",
  "Select the first token": "حدد الرمز المميز الأول",
  "Select the second token": "حدد الرمز المميز الثاني",
  "Only tokens that paired with ": "الرموز المميزة فقط المقترنة بـ",
  " are listed": "مدرجة ",
  "The following tokens are listed in TiFi Bank": "TiFi الرموز المميزة التالية مُدرجة في بنك",
  "Stay Tuned!": "!ابقوا متابعين",
  "TiFi Bank Portfolio Page will be available in August 2022!": "!ستكون متاحة في أغسطس 2022 TiFi صفحة محفظة بنك",
  "TiFi Bank Staking will be available in August 2022!": " !سيكون متاحًا في أغسطس 2022 TiFi Bank Staking",
  "Your Liquidity": "السيولة الخاصة بك",
  "Connect to a wallet to view your liquidity.": ".اتصل بالمحفظة لعرض السيولة الخاصة بك",
  "Add Liquidity": "إضافة السيولة",
  "Enter Amount": "أدخل المبلغ",
  "Approved! Now you can remove liquidity.": ".موافق عليه! الآن يمكنك إزالة السيولة",
  "Liquidity Removal Success!": "!نجاح إزالة السيولة",
  "Remove": "إزالة",
  "liquidity": "السيولة",
  "To receive": "لاستقبال",
  "and": "و",
  "Amount (LP Tokens to Remove / Total)": "(المراد إزالتها / الإجمالي LP المبلغ (رموز",
  "Max": "الأعلى",
  "You will Receive": "ستستلم",
  "Pooled": "مجمعة",
  "Enable": "يُمكَِن",
  "Liquidity Pool Token Balance": "الرصيد المميز لتجمع السيولة",
  "Share of pool": "حصة البلياردو",
  "Add liquidity instead": "أضف السيولة بدلاً من ذلك",
  "No liquidity found": "لا توجد سيولة",
  "Approved! Now you can add liquidity.": ".موافق عليه! يمكنك الآن إضافة السيولة",
  "Liquidity Provision Success!": "!نجاح توفير السيولة",
  "Tip: By adding liquidity you'll earn 0.18% of all trades on this pair proportional to your share of the pool. Fees are added to the pool, accrue in real time and can be claimed by withdrawing your liquidity.": "نصيحة: بإضافة السيولة ، ستربح 0.18٪ من جميع التداولات على هذا الزوج بما يتناسب مع حصتك في التجمع. يتم إضافة الرسوم إلى المجمع ، وتراكم في الوقت الفعلي ويمكن المطالبة بها عن طريق سحب السيولة الخاصة بك.",
  "Input": "إدخال",
  "Select a token": "حدد رمزًا مميزًا",
  "Price and pool share": "السعر وحصة التجمع",
  "Insufficent balance": "الرصيد غير الكافي",
  "Supply": "إمداد",
  "Connect to a wallet to add liquidity.": ".اتصل بمحفظة لإضافة السيولة",
  "Insufficient balance to perform this transaction.": ".رصيد غير كاف لأداء هذه المعاملة",
  "Pool Analytics": "Pool Analytics",
  "Stake Analytics": "Stake Analytics",
  "Your Stake": "Your Stake",
  "TIFI APY": "TIFI APY",
  "WBNB APY": "WBNB APY",
  "The TIFI APY when staking TIFI. It is updated every day at 01:00 UTC.": "The TIFI APY when staking TIFI. It is updated every day at 01:00 UTC.",
  "The WBNB APY when staking TIFI. This is the APY of average case. It is updated every day at 01:00 UTC.": "The WBNB APY when staking TIFI. This is the APY of average case. It is updated every day at 01:00 UTC.",
  "Connect to a wallet to view your stake records.": "Connect to a wallet to view your stake records.",
  "Stake TIFI": "Stake TIFI",
  "Go to TiFi.net": "Go to TiFi.net",
  "TiFi Bank Home Page": "TiFi Bank Home Page",
  "View TIFI on CoinMarketCap": "View TIFI on CoinMarketCap",
  "No stake record found": "No stake record found",
  "Notice: TiFi Bank charges 0.02 BNB of transaction fee for every stake, there are no fees when unstake. To receive the rewards, you have to stake TIFI at least 30 days. You will also get WBNB reward if you stake for more than 180 days.": "Notice: TiFi Bank charges 0.02 BNB of transaction fee for every stake, there are no fees when unstake. To receive the rewards, you have to stake TIFI at least 30 days. You will also get WBNB reward if you stake for more than 180 days.",
  "Connect to a wallet to stake.": "Connect to a wallet to stake.",
  "Staked on": "Staked on",
  "Unstake now, you will get": "Unstake now, you will get",
  ", you will get at least": ", , you will get at least",
  "After": "After",
  "Unstake": "Unstake",
  "Total Amount of TIFI staked on ": "Total Amount of TIFI staked on ",
  "TIFI Staked": "TIFI Staked",
  "Reward": "Reward",
  "Notice: You are not getting the full reward of extra TIFI and WBNB because the staking time is less than 180 days!": "Notice: You are not getting the full reward of extra TIFI and WBNB because the staking time is less than 180 days!",
  "Enable Stake": "Enable Stake",
  "Approved! Now you can stake.": "Approved! Now you can stake.",
  "Click on the column name to sort pairs by its volume or APR.": "Click on the column name to sort pairs by its volume or APR.",
  "Pools": "Pools",
  "Name": "Name",
  "APY": "APY",
  "Action": "Action",
  "Track the earning trends for staking": "Track the earning trends for staking",
  "Stake APY Charts": "Stake APY Charts",
  "TIFI Stake Reward APY": "TIFI Stake Reward APY",
  "TIFI Reflection Reward APY": "TIFI Reflection Reward APY",
  "WBNB Stake Reward APY": "WBNB Stake Reward APY",
  "Note: The TIFI APY chart shows the comparison of TIFI reflection rate (holding TIFI in wallet) and TIFI staking rate. Both APY rates are determined by trading volume, but the staking takes extra trading fees to pay the earnings.": "Note: The TIFI APY chart shows the comparison of TIFI reflection rate (holding TIFI in wallet) and TIFI staking rate. Both APY rates are determined by trading volume, but the staking takes extra trading fees to pay the earnings.",
  "Note: The WBNB APY chart shows the APY earning rate for average users. You can only get the WBNB earning after your have staked TIFI for more than 180 days.": "Note: The WBNB APY chart shows the APY earning rate for average users. You can only get the WBNB earning after your have staked TIFI for more than 180 days.",
  "GO TO STAKE": "GO TO STAKE",
  "Your Net Worth": "صافي ثروتك",
  "Circulating Supply": "العرض المتداول",
  "TVL": "TVL",
  "Daily Trading Volume": "حجم التداول اليومي",
  "Burned to date": "أحرق حتى الآن",
  "Holders": "حوامل",
  "Crypto Loan": "قرض العملة المشفرة",
  "Supply crypto assets to earn interests and get fast loan without credit check.": "قم بتوريد أصول التشفير لكسب الفوائد والحصول على قرض سريع دون التحقق من الائتمان",
  "Supplied Assets": "الأصول الموردة",
  "Max. Borrow": "الأعلى. يستعير",
  "Current Borrow": "الاقتراض الحالي",
  "Health Level": "المستوى الصحي",
  "VERY GOOD": "جيد جدًا",
  "Lending APY": "إقراض APY",
  "Borrowing APY": "استعارة APY",
  "Available": "متاح",
  "Deposit": "إيداع",
  "Withdraw": "ينسحب",
  "Borrow": "يستعير",
  "Repay": "السداد",
  "Credit": "ائتمان",
  "Debt": "دَين",
  "Assets": "دَين",
  "Loan": "يُقرض",
  "Lottery": "اليانصيب"
}
export default ar